import { createSelector } from 'reselect'
import modelsSelector from './modelsSelector'

const modelsLoadedSelector = createSelector(
    modelsSelector,
    (models): boolean => models.length > 0,
)

export default modelsLoadedSelector
